import { CommonPageTDK, DynamicHead } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { useUserTDK } from '../shared/use-user-tdk';
import { FC } from 'react';
import { $SEOCurrentTraffic } from 'shared/atoms/common/traffic';

const CanonicalLinkComponent: FC = () => {
  const canonicalUrl = useAtomValue($SEOCurrentTraffic).canonicalUrl;
  return (
    <DynamicHead>
      <link rel="canonical" href={canonicalUrl} />
    </DynamicHead>
  );
};

class PageTDK extends CommonPageTDK {
  CanonicalLink = () => <CanonicalLinkComponent />;
}

export const UserTDK = () => {
  return <PageTDK {...useUserTDK()} />;
};
